import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { Link } from "react-router-dom";
const Header = () => {
  const theme = useTheme();
  // Verifica se a tela é menor que 'md' (960px por padrão no MUI) para alternar o menu
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Cores personalizadas baseadas no seu código original
  const primaryColor = "rgb(124, 58, 237)"; // Roxo
  const textColorSecondary = "#464467";
  const textColorPrimary = "#1F1B2E";
  const borderColor = "rgba(225, 224, 245, 0.7)";

  // Estilo comum para os links de âncora desktop
  const anchorLinkStyle = {
    textDecoration: "none",
    color: textColorSecondary,
    fontSize: "0.875rem",
    fontWeight: 500,
    transition: "color 0.2s",
    "&:hover": {
      color: textColorPrimary,
    },
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: theme.zIndex.appBar,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(8px)",
        borderBottom: `1px solid ${borderColor}`,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{
            height: 64,
            display: "flex",
            justifyContent: "between",
            alignItems: "center",
          }}
        >
          {/* Logo e Nome */}
          <Box sx={{ flexGrow: isMobile ? 1 : 0, display: "flex", alignItems: "center" }}>
            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {/* O caminho da imagem (src) deve ser ajustado aqui */}
              <Typography
                variant="h6"
                component="span"
                sx={{
                  fontWeight: "bold",
                  color: primaryColor,
                  fontSize: "1.25rem",
                }}
              >
                FazPedido
              </Typography>
            </Box>
          </Box>

          {/* Navegação Principal (Desktop) */}
          {!isMobile && (
            <Box
              component="nav"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                marginLeft: "auto",
              }}
            >
              <Box component="a" href="#resultados" sx={anchorLinkStyle}>
                Resultados
              </Box>
              <Box component="a" href="#como-funciona" sx={anchorLinkStyle}>
                Como funciona
              </Box>
              <Box component="a" href="#por-que" sx={anchorLinkStyle}>
                Por que FazPedido
              </Box>
              <Box component="a" href="#planos" sx={anchorLinkStyle}>
                Planos
              </Box>

              {/* Botão Entrar */}
              <Button
                component={RouterLink}
                to="/auth/login"
                sx={{
                  borderRadius: "50px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  color: textColorSecondary,
                  px: 2,
                  "&:hover": {
                    backgroundColor: "rgba(124, 58, 237, 0.1)",
                    color: textColorPrimary,
                  },
                }}
              >
                Entrar
              </Button>

              {/* Botão Criar conta */}
              <Button
                component={RouterLink}
                to="/auth/register"
                variant="contained"
                sx={{
                  borderRadius: "50px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  backgroundColor: primaryColor,
                  color: "#fff",
                  px: 2.5,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: primaryColor,
                    opacity: 0.9,
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                  },
                }}
              >
                Criar conta
              </Button>
            </Box>
          )}

          {/* Botões Mobile */}
          {isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                component={Link}
                to="/auth/login"
                sx={{
                  borderRadius: "50px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  color: textColorSecondary,
                  px: 1.5,
                  "&:hover": {
                    backgroundColor: "rgba(124, 58, 237, 0.1)",
                  },
                }}
              >
                Entrar
              </Button>
              <Button
                component={Link}
                to="/auth/register"
                variant="contained"
                sx={{
                  borderRadius: "50px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  backgroundColor: primaryColor,
                  color: "#fff",
                  px: 2,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: primaryColor,
                    opacity: 0.9,
                  },
                }}
              >
                Criar
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;